import { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';

const PLATFORMS = [
  { id: 'twitter', label: 'Twitter / X', icon: '𝕏' },
  { id: 'linkedin', label: 'LinkedIn', icon: 'in' },
  { id: 'instagram', label: 'Instagram', icon: '◉' },
  { id: 'facebook', label: 'Facebook', icon: 'f' },
  { id: 'blog', label: 'Blog Post', icon: '✦' },
  { id: 'email', label: 'Email', icon: '✉' },
];

export default function ContentPage() {
  const [platform, setPlatform] = useState('twitter');
  const [topic, setTopic] = useState('');
  const [tone, setTone] = useState('Professional');
  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');
  const { updateCredits } = useAuth();

  async function generate() {
    if (!topic.trim() || loading) return;
    setError(''); setLoading(true); setOutput('');
    try {
      const res = await api.post('/content/generate', { platform, topic, tone });
      setOutput(res.data.data.content);
      updateCredits(res.data.credits_remaining);
    } catch (e) { setError(e.response?.data?.error || 'Failed'); } finally { setLoading(false); }
  }

  return (
    <div className="fade-up">
      <div className="page-header">
        <h1 className="page-title">Content Writer</h1>
        <p className="page-sub">AI-powered content for 6 platforms — 3 credits per generation</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#6B7280', marginBottom: 8 }}>Platform</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {PLATFORMS.map(p => (
              <button key={p.id} onClick={() => setPlatform(p.id)} className={`btn ${platform === p.id ? 'btn-black' : 'btn-white'}`} style={{ gap: 6 }}>
                <span>{p.icon}</span>{p.label}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 12, marginBottom: 12 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#6B7280', marginBottom: 6, display: 'block' }}>Topic *</label>
            <input className="input" placeholder="What should we write about? e.g. best SEO tools for startups" value={topic} onChange={e => setTopic(e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#6B7280', marginBottom: 6, display: 'block' }}>Tone</label>
            <select className="input" value={tone} onChange={e => setTone(e.target.value)}>
              {['Professional','Casual','Funny','Inspirational','Educational','Urgent'].map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
        </div>

        <button className="btn btn-orange" onClick={generate} disabled={loading || !topic.trim()}>
          {loading ? 'Generating...' : `✦ Generate ${PLATFORMS.find(p=>p.id===platform)?.label}`}
        </button>
        {error && <div style={{ marginTop: 10, color: '#FF3D57', fontSize: 13, background: '#FFEBEE', padding: '8px 12px', borderRadius: 6 }}>{error}</div>}
      </div>

      {output && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <span style={{ fontWeight: 700, fontSize: 14 }}>Generated Content</span>
            <button className="btn btn-white btn-sm" onClick={() => navigator.clipboard.writeText(output)}>⧉ Copy</button>
          </div>
          <div style={{ background: '#FAFBFC', border: '1px solid #E5E7EB', borderRadius: 6, padding: 16, whiteSpace: 'pre-wrap', fontSize: 13, lineHeight: 1.7 }}>{output}</div>
        </div>
      )}
    </div>
  );
}
